export const changePassword = {
  changeCurrentPassword: "Current Password",
  changeNewPassword: "New Password",
  changeConfirmNewPassword: "Confirm New Password",
  changePasswordMessage: "Please enter your password!",
  changePasswordError: "The password does not match!",
  changePasswordBtn: "Submit",
};
